import { combineReducers } from 'redux';
import * as actionTypes from '../actions/types';

import appReducer from './appReducer';
import bcReducer from './businessChallengeReducer';
import personasReducer from './personasReducer';
import milestonesReducer from './milestonesReducer';
import ideasReducer from './ideasReducer'; // delete me
import connectorsReducer from './milestoneConnectorsReducer';
import quipReducer from './quipReducer';
import productsReducer from './productsReducer';
import collaboratorReducer from './collaboratorReducer';

const reducer = combineReducers({
  /* app top-level reducers */
  app: appReducer,
  businessChallenge: bcReducer,
  personas: personasReducer,
  milestones: milestonesReducer,
  ideas: ideasReducer,
  milestoneConnectors: connectorsReducer,
  quip: quipReducer,
  products: productsReducer,
  collaborators: collaboratorReducer,
});

const rootReducer = (state, action) => {
  // when a PURGE action is dispatched it will reset redux state
  switch (action.type) {
    case actionTypes.PURGE:
      return reducer(undefined, action);
    default:
      return reducer(state, action);
  }
};

export default rootReducer;
